import { withTranslation } from 'react-i18next';
import { withTheme } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { setAvailableMics, setMicSelected, startRecord, stopRecord } from '../../actions';
import { resetAudioRecorderState, resetRecordingContext, setHasMicrophoneRestarted, setIsRestartingMicrophone, setRecordingContext, } from '../../actions/audio-recorder';
import { addNotification } from '../../actions/cc-mode';
import { setAudioParamsSent } from '../../actions/session';
import withMediaDevices from './withMediaDevices';
import AudioRecorder from './AudioRecorder';
const mapStateToProps = ({ audioRecorder: { hasMicrophoneRestarted, isRestartingMicrophone, recordingContext }, scribeConversation: { availableMics, curseFilter, hasRecorded, lang, micIdSelected, onlyInternalAudio, recording, speechLang, status, }, scribeDashboard: { scribeTrainingSourceNode, scribeTrainingAudioStreamAC }, scribeSession: { audioParamsSent, captioner, selectedCaptions }, scribeTranscriptUI: { fullScreen, electronCaptionMode }, }) => ({
    audioParamsSent,
    availableMics,
    curseFilter,
    electronCaptionMode,
    fullScreen,
    hasMicrophoneRestarted,
    hasRecorded,
    isMuted: status.conversationMode === 'public-muted',
    isRestartingMicrophone,
    lang,
    micIdSelected,
    onlyInternalAudio,
    participants: status.participants,
    recording,
    recordingContext,
    scribeTrainingSourceNode,
    scribeTrainingAudioStreamAC,
    selectedCaptions,
    speechLang,
    status,
    user: captioner,
});
const mapDispatchToProps = {
    addNotification,
    resetAudioRecorderState,
    resetRecordingContext,
    setAvailableMics,
    setMicSelected,
    setAudioParamsSent,
    setHasMicrophoneRestarted,
    setIsRestartingMicrophone,
    setRecordingContext,
    startRecord,
    stopRecord,
};
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTheme(withMediaDevices(AudioRecorder))));
